import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LockKey } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-lg border border-brand-sand bg-brand-cream px-4 py-3 text-sm text-brand-navy outline-none focus:border-brand-teal focus:ring-2 focus:ring-brand-teal/30";

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-navy px-5 grain relative overflow-hidden">
      <div className="relative z-10 w-full max-w-md rounded-3xl bg-white p-8 md:p-10 shadow-2xl" data-testid="admin-login-card">
        <img src="/assets/cluetrip-logo.png" alt="Cluetrip" className="h-11 w-auto mb-8" />
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-teal/10 text-brand-teal mb-4"><LockKey size={24} weight="duotone" /></span>
        <h1 className="font-heading text-3xl text-brand-navy">Admin Login</h1>
        <p className="text-sm text-[#8B89A4] mt-1 mb-7">Manage packages & customer enquiries.</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" placeholder="Email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" placeholder="Password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="login-submit" disabled={loading} className="w-full rounded-full bg-brand-orange px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-brand-orangedark disabled:opacity-60">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
